<template>
  <div id="app-container">
    <!-- 封面 -->
    <reader-cover :content="_.get(sections, 'info')" :PDFDownloadURL="PDFDownloadURL" :loading="loading" @start="showSummary"/>

    <div v-if="!loaded" class="app-loading">
      <!-- <img src="@/assets/logo.png" class="logo"/> -->
      <div class="app-loading-content">
        <el-row type="flex" class="row-bg" justify="center" :gutter="40">
          <el-col :span="11" :lg="9" :xl="7" class="service-image">
            <img src="@/assets/factory_vr.png"/>
          </el-col>
          <el-col :span="11" :lg="9" :xl="7" class="service-detail">
            <h1>3D AUDIT SERVICE</h1>
            <p>3D Factory Assessment Service supervise suppliers make it possible by with 360 degree by applying VR panoramic camera technology. Sitting at office, you may easily get a 360-degree view of the factory. With professional comments by our inspector, every detail can be spotted on your screen.</p>
            <!-- <a v-if="!loading" class="el-button el-button--warning is-round" href="https://www.testcoo.com/factoryVrDetail">Learn More</a> -->
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 帮助 -->
    <transition name="el-fade-in-linear">
      <div v-show="showFAQ" class="faq" @click="showFAQ = null">
        <img src="@/assets/faq.png"/>
        <span v-text="$t('view.press')"></span>
      </div>
    </transition>

    <div id="main">
      <div id="pano"></div>

      <template v-for="hotspot in _.filter(hotspots, hotspot => !hotspot.hidden)">
        <div v-if="hotspot.type == 'info'" class="hotspot-info" v-show="hotspot.hotspot" :class="{'focus': hotspot._focus}" :id="hotspot.uid" :key="hotspot.uid" @click="handleFocusHotspot(hotspot)">
          <div :class="`hotspot hotspot-bg-${_.get(evaluations, `${_.get(hotspot, 'level')}.color`)}`">
            <div class="out"></div>
            <div class="in"></div>
          </div>
          <transition v-on:enter="entryHotspotDesc" v-on:leave="leaveHotspotDesc">
            <div v-show="hotspot._content == 1">
              <div v-if="hotspot.description" class="hotspot-desc" v-html="hotspot.description"/>
              <svg width="80" height="95" xmlns="http://www.w3.org/2000/svg" class="hotspot-leader-line">
                <polyline points="55,95 20,0 0,0"/>
              </svg>
            </div>
          </transition>
          <div v-if="hotspot.title" v-show="hotspot._content != 1" class="title">
            {{ hotspot.title }}
          </div>
        </div>

        <div v-else-if="hotspot.type == 'link'" v-show="hotspot.hotspot" class="hotspot-link" :id="hotspot.uid" :key="hotspot.uid" @click="handleSwitch(hotspot)">
          <div class="out">
            <svg width="50px" height="23px" viewBox="0 0 50 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-458.000000, -456.000000)">
                  <g transform="translate(458.000000, 417.000000)">
                    <g transform="translate(0.000000, 39.000000)">
                      <path class="arrow-shadow" d="M26.2102529,5.319443 L44.6337264,13.1980101 L36.703,13.197443 L26.2619228,8.23787369 C21.8067118,10.2564684 18.2628184,11.9100465 15.6302424,13.1986079 L6,13.1980101 L26.2102529,5.319443 Z" fill-opacity="0.650047462" fill="#000000"></path>
                      <path class="arrow-shadow" d="M25.6967403,10.319443 L49.0514303,22.2842272 L38.034,22.372443 L25.3602585,14.6652338 L10.93,22.592443 L2.13162821e-13,22.680598 L25.6967403,10.319443 Z" fill-opacity="0.769081382" fill="#000000"></path>
                      <path class="arrow" d="M25.925573,5.34031883 L49.2802629,17.305103 L38.2628327,17.3933188 L25.5890912,9.68610968 L11.1588327,17.6133188 L0.228832663,17.7014738 L25.925573,5.34031883 Z" fill="#FFFFFF"></path>
                      <path class="arrow" d="M25.9195152,3.50830476e-14 L44.3429886,7.87856713 L36.4122623,7.878 L25.9711851,2.9184307 C21.5159741,4.93702542 17.9720806,6.59060349 15.3395047,7.87916492 L5.70926225,7.87856713 L25.9195152,3.50830476e-14 Z" fill="#FFFFFF"></path>
                      <path class="arrow-fixed" d="M25.925573,5.34031883 L49.2802629,17.305103 L38.2628327,17.3933188 L25.5890912,9.68610968 L11.1588327,17.6133188 L0.228832663,17.7014738 L25.925573,5.34031883 Z" fill="#FFFFFF"></path>
                      <path class="arrow-fixed" d="M25.9195152,3.50830476e-14 L44.3429886,7.87856713 L36.4122623,7.878 L25.9711851,2.9184307 C21.5159741,4.93702542 17.9720806,6.59060349 15.3395047,7.87916492 L5.70926225,7.87856713 L25.9195152,3.50830476e-14 Z" fill="#FFFFFF"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>

          <div v-if="hotspot.title" class="title">
            {{ hotspot.title }}
          </div>
        </div>
      </template>

      <!-- 导航 -->
      <reader-nav-menu ref="navMenu" :show="showSceneContent" :menus="menus" :evaluations="evaluations" @change="handleMenuChange"/>

      <!-- 工具栏 -->
      <div v-show="showTools" class="bottom-controls">
        <div class="tools">
          <a class="scene" @click="showSummary">
            <span v-text="$t('view.summary')"></span>
          </a>
          <a class="info" :class="{focus: showSceneContent}" @click="showSceneContent = !showSceneContent">
            <span v-text="$t('view.contents')"></span>
          </a>
          <a class="floor" :class="{focus: showFloorPlann}" @click="showFloorPlann = !showFloorPlann">
            <span v-text="$t('view.plan')"></span>
          </a>
          <a class="full" @click="fullscreen">
            <span v-text="$t('view.fullscreen')"></span>
          </a>
          <div v-if="PDFDownloadURL">
            <a target="_blank" class="export" :href="PDFDownloadURL">
              <span v-text="$t('view.report')"></span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div id="summary_content" :class="{'summary-content': isSummary, 'summary-content-hidden': summaryIsHiding}">
      <div v-if="isSummary" id="summary_title" class="title">
        {{$t('view.summary')}}
        <i class="el-icon-close" @click="hideSummary"></i>
      </div>
      <div class="summary-content-flex">
        <!-- 菜单栏 -->
        <div class="slide-menu">
          <template v-for="(menu, index) in _.filter(menus, {type: 'audit'})">
            <div
              class="slide-menu-item"
              :key="index"
              :class="{'selected': menu._active}"
              @click="hanldeMenuClick(menu)">
              {{ menu.hotspot.title }}
            </div>
          </template>
        </div>
        
        <!-- 弹出框内容 -->
        <reader-content
          ref="content"
          :isSummary="isSummary"
          :hotspot="focusHotspot"
          @preview="showPreviewImages"
          @input="handleMenuChange"/>

        <!-- 平面图 -->
        <reader-floor-plan 
          ref="floorPlan"
          :show="showFloorPlann"
          :current-scene="currentScene"
          :current-panorama="currentPanorama"
          :scenes="scenes"
          :display3D="isSummary"
          :buildings="buildings"
          @input="handleFloorSelect"/>
      </div>
    </div>

    <image-viewer v-show="previewIndex !== null" :urlList="previewImages" :initial-index="previewIndex" :on-close="hidePreviewImages"/>
  </div>
</template>

<script>
import Marzipano from 'marzipano'
import Hammer from 'hammerjs'
import Cookies from 'js-cookie'

import ImageViewer from '@/components/Image/viewer'
import AnimeMixin from './mixins/anime'
import labelMixin from '@/mixins/label'
import ReaderFloorPlan from './FloorPlan'
import ReaderContent from './Content'
import ReaderCover from './Cover'
import ReaderNavMenu from './NavMenu'

import request from '@/utils/request'
import helpers from '@/utils/helpers'
import parseSection from '@/utils/parseSection'
import { fetchReport, fetchShareReport } from '@/api/report'

const DEFAULT_FOV = 1.35, DEFAULT_YAW = 90

export default {
  name: 'Reader',
  components: { ImageViewer, ReaderFloorPlan, ReaderContent, ReaderCover, ReaderNavMenu },
  mixins: [ AnimeMixin, labelMixin ],
  provide() {
    return {
      hideAllHotspots: this.hideAllHotspots,
      showAllHotspots: this.showAllHotspots,
      getCurrentMenuChildren: () => {
        return this._.flatten(this._.values(this.$refs.navMenu.activeMenu.children), 1)
      },
      getPanoramaByUid: uid => {
        return this._.get(this.panoramas, uid)
      }
    }
  },
  data() {
    return {
      loading: false,
      reportId: null,
      reportConfigs: null,
      viewer: null,
      hotspots: [],
      scenes: [],
      sections: null,
      showScene: false,
      showSceneContent: false,
      showFloorPlann: true,
      showTools: false,
      showFAQ: false,

      currentScene: null,
      currentPanorama: null,

      menus: null,
      focusHotspot: null,
      allHotspotsIsHidden: false,

      previewImages: [],
      previewIndex: null,

      transitionDuration: 1000,
      
      isSummary: false,
      summaryIsHiding: false,

      PDFDownloadURL: null,

      loaded: false,
    }
  },
  watch: {
    currentPanorama(panorama) {
      const scene = this._.find(this.scenes, scene => {
        return this._.find(scene.panoramas, { uid: panorama.uid })
      })
      if (this.currentScene !== scene) {
        this.currentScene = scene
      }
    },
    focusHotspot(hotspot, oldHotspot) {
      this.$nextTick(() => {
        if (hotspot) {
          if (hotspot._content == 2) {
            hotspot._content = 1
          } else {
            hotspot._content = 2
            hotspot._callback = () => {
              hotspot._content = 1
            }
          }
          hotspot._focus = true
        }
        if (oldHotspot) {
          oldHotspot._content = 0
          oldHotspot._focus = false
        }
      })
    },
  },
  computed: {
    panoramas() {
      return this._.mapKeys(this._.flatten(this._.map(this.scenes, 'panoramas'), 1), panorama => panorama.uid)
    },
    marks() {
      return this._.filter(this.hotspots, hotspot => hotspot.type === 'info' && ['positive', 'negative'].includes(hotspot.level))
    },
    buildings() {
      return this._.get(this.sections, 'buildings')
    },
    needInputPassword() {
      return this._.startsWith(this.$route.query.token, '_')
    }
  },
  mounted() {
    this.viewer = new Marzipano.Viewer(document.getElementById('pano'), {stage: {progressive: true}})
    const hammerTouch = this.viewer._hammerManagerTouch
    const hammerMouse = this.viewer._hammerManagerMouse

    const tapRecognizerMouse = new Hammer.Tap({ taps: 2, posThreshold: 20 })
    hammerMouse.manager().add(tapRecognizerMouse)
    hammerMouse.on('tap', this.zoomOnTap)
    const tapRecognizerTouch = new Hammer.Tap({ taps: 2, posThreshold: 50 })
    hammerTouch.manager().add(tapRecognizerTouch)
    hammerTouch.on('tap', this.zoomOnTap)

    this.reportId = this._.get(this.$route.query, 'id')

    this.loadData()
  },
  methods: {
    async inputPassword(token) {
      const savedPassword = Cookies.get(token)
      if (savedPassword) {
        Cookies.remove(token)
        return savedPassword
      } else {
        const inputValue = await this.$prompt('Please enter password, thanks.', 'Prompt', {
          confirmButtonText: 'OK',
          showCancelButton: false
        })
        return inputValue.value
      }
    },

    // 初始化加载数据
    async loadData() {
      let response = null
      let token = this.$route.query.token
      this.loaded = false
      this.loading = true
      try {
        if (token) {
          const params = this._.cloneDeep(this.$route.query)
          let password = null

          if (this.needInputPassword) {
            password = await this.inputPassword(token)
            params['password'] = password
          }
          response = await fetchShareReport(params)
          if (password) {
            Cookies.set(token, password)
          }
        } else {
          response = await fetchReport(this.reportId)
        }
        if (response) {
          this.setReportConfig(response.configs)
          this.setReportData(response.data)
        }
      } catch (e) {
        let message = this._.get(e.response, 'data.message', e)
        if (this.needInputPassword && message === 'wrong password') {
          await this.$alert(message, 'Prompt', { confirmButtonText: 'Try Again', type: 'error' })
          setTimeout(() => { this.loadData() }, 500)
        } else {
          await this.$alert(message, 'Prompt', { confirmButtonText: 'OK', type: 'error' })
        }
      } finally {
        this.loading = false
      }
    },
    setReportData(reportData) {
      this.loaded = true
      if(reportData.locale){
        this.$i18n.locale = reportData.locale == 'zh_CN'?'zh':reportData.locale
      }
      const data = this._.get(reportData, 'review.inspection_results')
      if (data) {
        // this.PDFDownloadURL = this._.get(data, 'pdf') || (process.env.VUE_APP_BASE_URL + '/admin' + this._.get(reportData, '_links.browse'))
        this.PDFDownloadURL = this._.get(reportData, 'files.admin_reports.0.url')
        if (data.source_base_url) {
          helpers.setSourceBaseUrl(data.source_base_url)
        }
        const hotspotContainer = []
        this.sections = data.sections
        this.scenes = this._.each(data.scenes, scene => {
          // scene.uid = this._.get(scene, 'panoramas.0.uid')
          this._.each(scene.panoramas, panorama => {
            panorama.parentUid = scene.uid
            panorama.preview = helpers.getPreviewSource(panorama)
          })
          this._.each(scene.checkpoints, hotspot => {
            hotspot._content = 0 // 弹框
            hotspot._focus = false
            hotspot.hidden = false
            hotspotContainer.push(hotspot)
          })
          this._.each(scene.links, hotspot => {
            hotspot.hidden = false
            hotspotContainer.push(hotspot)
          })
          this._.each(scene.processes, hotspot => {
            hotspot.hidden = true
            hotspotContainer.push(hotspot)
          })
        })

        this.hotspots = hotspotContainer

        // 菜单栏
        this.loadMenus()

        this.$nextTick(() => {
          this._.each(this.scenes, scene => {
            this.createPanorama(this._.first(scene.panoramas))
          })
        })
      }
    },

    // 初始化全景图
    createPanorama(panorama) {
      const source = new Marzipano.ImageUrlSource(tile => {
        return { url: helpers.getTileSource(panorama, tile) }
      })
      const geometry = new Marzipano.CubeGeometry(panorama.levels)
      const limiter = Marzipano.RectilinearView.limit.hfov(50 * Math.PI / 180, 130 * Math.PI / 180)
      const view = new Marzipano.RectilinearView({
        pitch: 0,
        yaw: -panorama.location.rotate * Math.PI / 180,
        fov: DEFAULT_FOV
      }, limiter)
      panorama.scene = this.viewer.createScene({
        source: source,
        geometry: geometry,
        view: view,
        pinFirstLevel: true
      })
      panorama.scene.addEventListener('viewChange', () => this.handleViewChange(panorama))

      this._.each(this.hotspots, hotspot => {
        if (hotspot.panoramaUid === panorama.uid && !hotspot.hidden) {
          this.createHotspot(hotspot, panorama)
        }
      })
    },

    // 创建热点
    createHotspot(wrapper, panorama) {
      wrapper.hotspot = panorama.scene.hotspotContainer().createHotspot(
        document.querySelector(`#${wrapper.uid}`),
        wrapper.position
      )
      if (this.allHotspotsIsHidden) {
        wrapper.hotspot.hide()
      }
    },

    // 点击放大
    zoomOnTap(e) {
      const rect = document.getElementById('pano').getBoundingClientRect()
      const coords = this.viewer.view().screenToCoordinates({
        x: e.center.x - rect.x,
        y: e.center.y - rect.y
      })
      coords.fov = this.viewer.view().fov() * 0.8
      this.viewer.lookTo(coords, {transitionDuration: 300})
    },
    
    // 手动点击切换场景
    handleSwitch(hotspot) {
      const uid = this._.isString(hotspot) ? hotspot : this._.get(hotspot, 'link')
      const panorama = this._.find(this.panoramas, { uid })
      if (panorama) {
        let defaultCenterPosition = null
        const scene = this._.find(this.scenes, scene => {
          return this._.find(scene.panoramas, { uid: uid })
        })

        if (this._.get(this.currentScene, 'uid') !== scene.uid) {
          const menu = this._.find(this.menus, {
            type: 'audit',
            sceneUid: scene.uid
          })
          if (menu && menu.sceneUid == uid) {
            defaultCenterPosition = menu.hotspot.position
            this.$refs.navMenu.hanldeMenuClick(menu, true)  // 菜单栏
          }
        }
        this.switchTo(panorama, null, defaultCenterPosition)
      }
    },

    // 切换
    switchTo(panorama, done, defaultCenterPosition) {
      if (panorama.scene) {
        this._switchTo(panorama, done, defaultCenterPosition)
      } else {
        this.createPanorama(panorama)
        this.$nextTick(() => {
          this._switchTo(panorama, done, defaultCenterPosition)
        })
      }
    },

    _switchTo(panorama, done, defaultCenterPosition) {
      let diffRotate = 0
      const oldView = this.viewer.view()
      const newScene = panorama.scene
      let defaultPosition = null
      let defaultFov = DEFAULT_FOV
      if (this.currentPanorama === panorama) {
        defaultCenterPosition = null
      } else {
        if (this.currentPanorama) {
          diffRotate = (this.currentPanorama.location.rotate - panorama.location.rotate) / 180 * Math.PI
        }
        this.currentPanorama = panorama
      }

      if (oldView) {
        defaultPosition = defaultCenterPosition ? defaultCenterPosition : {
          yaw: oldView.yaw() + diffRotate,
          pitch: oldView.pitch()
        }
        defaultFov = oldView.fov()
      } else {
        defaultPosition = defaultCenterPosition ? defaultCenterPosition : this._.get(this._.find(this.hotspots, {
          panoramaUid: panorama.uid,
          type: 'link'
        }), 'position')
      }

      if (defaultPosition) {
        newScene.view().setYaw(defaultPosition.yaw)
        newScene.view().setPitch(defaultPosition.pitch)
      }
      if (defaultFov) {
        newScene.view().setFov(defaultFov)
      }

      done = done || function() {}
      if (this.viewer.scene() === newScene) {
        done(newScene, true)
      } else {
        newScene.switchTo({transitionDuration: this.transitionDuration * .6}, () => {
          done(panorama.scene, false)
          this.handleViewChange(panorama)
        })
      }
    },

    // 切换焦点
    switchToHotspot(hotspot, options, done) {
      this.focusHotspot = hotspot 

      const doneCallback = () => {
        done && done()
        if (hotspot._callback) {
          hotspot._callback()
          hotspot._callback = null
        }
      }

      const position = hotspot.position
      const panorama = this._.find(this.panoramas, { uid: hotspot.panoramaUid })

      if (!position) {
        return doneCallback()
      }

      options = { controlsInterrupt: true, ...options }
      if (!options.transitionDuration && this.viewer.view()) {
        let duration = hotspot.duration
        options.transitionDuration = duration ? duration : this.getSwitchToDistance(hotspot.position) * this.transitionDuration * .3
      }

      this.switchTo(panorama, (scene, isSame) => {  
        !isSame && (options.transitionDuration = 0)
        // 转动焦点
        setTimeout(doneCallback, Math.min(options.transitionDuration - 50, 0))
        scene.lookTo({yaw: position.yaw, pitch: position.pitch}, options, () => {
          // doneCallback()
        })
      }, position)
    },

    // 获取2个点之间的距离
    getSwitchToDistance(position) {
      const oldYaw = this.viewer.view().yaw()
      const newYaw = position.yaw
      return newYaw * oldYaw > 0 ? Math.abs(newYaw - oldYaw) : Math.abs(newYaw + oldYaw)
    },

    handleViewChange(panorama) {
      const rotate = Number(this._.get(panorama, 'location.rotate', 0))
      this.$refs.floorPlan.setDirectionRotate(panorama.scene.view().yaw() / Math.PI * 180 + rotate)
    },

    // 点击标记点
    handleFocusHotspot(hotspot) {
      if (this.focusHotspot === hotspot) {
        hotspot._content = hotspot._content == 1 ? 0 : 1
      } else {
        hotspot._content = 2
        this.focusHotspot = hotspot
      }
    },

    showPreviewImages(files, index) {
      this.previewImages = files
      this.previewIndex = index
    },

    hidePreviewImages() {
      this.previewIndex = null
      this.previewImages = []
    },

    // 全屏
    fullscreen() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen()
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        }
      } 
    },
    
    // 报告菜单栏
    loadMenus() {
      const menus = []
      const hotspotGroups = this._.groupBy(this.hotspots, 'type')
      parseSection.init(this.sections, this.scenes)

      let processItems = [];

      // Manufacturing process
      
      // if (!this._.isEmpty(processes)) {
      //   processItems = this._.filter(this._.map(processes, process => {
      //     const hotspot = this._.find(this._.get(hotspotGroups, 'process'), { level: process.index })
      //     if (hotspot) {
      //       hotspot.title = process.name
      //       hotspot.description = parseSection.template('${' + `process_${process.index}` + '}')
      //     }
      //     return hotspot
      //   }))
      // }
      const processes = this._.get(this.sections, 'processes.items')
      this._.each(this._.get(hotspotGroups, 'process'), (hotspot) => {
        const p = this._.find(processes, {index: hotspot.level})
        if (p) {
          hotspot.title = `${p.name}`
          hotspot.description = parseSection.template('${' + `process_${p.index}` + '}')
          processItems.push(hotspot)
        } else {
          const l = hotspot.level
          hotspot.title = hotspot.description ? hotspot.description : l
          hotspot.description = ''
          const o = this._.find(menus, {type: 'process', key: l})
          if (o) {
            o.children[0].push(hotspot)
          } else {
            menus.push({
            type: 'process',
            key: l,
            hotspot: {
              title: l,
              description: '',
              type: 'list',
              content_style: '2'
            },
            children: [[hotspot]]
          })
          }
        }
      })

      if(!this._.isEmpty(processItems)) {  //判断是否有内容,有内容再添加标题
        menus.push({
          type: 'process',
          hotspot: {
            title: this.$i18n.locale == 'zh'?'功能分类':'Manufacturing process',
            description: '',
            type: 'list',
            content_style: '2'
          },
          children: [processItems]
        })
      }

      // Check points
      this._.each(this.scenes, (scene, index) => {
        const groups = this._.groupBy(scene.checkpoints, 'level')
        const children = {}
        for (let key of this._.keys(this.evaluations)) {
          if (this._.has(groups, key)) {
            children[key] = groups[key]
          }
        }
        const hotspot = scene.summary
        if (index === 0) {
          hotspot.description = '${base_information}'
        } else {
          hotspot.description = '${scene_' + scene.uid + '}\n\n' + (hotspot.description ? hotspot.description : '')
        }
        hotspot.description = parseSection.template(hotspot.description || '')
        hotspot.title = scene.name
        hotspot.panoramaUid = this._.get(this._.first(scene.panoramas), 'uid')
        
        menus.push({
          title: scene.name,
          hotspot: hotspot,
          sceneUid: this._.get(scene, 'uid'),
          type: 'audit',
          children: children
        })
      })

      // Inspections
      const inspections = this._.get(this.sections, 'inspections')
      if (inspections && inspections.pieces) {
        menus.push({
          type: 'other',
          hotspot: {
            title: 'Inspections',
            description: parseSection.template('${inspection}'),
            type: 'list',
            content_style: '2',
            files: inspections.files
          }
        })
      }

      // Certifications
      const certifications = this._.get(this.sections, 'certifications')
      if (inspections) {
        menus.push({
          type: 'other',
          hotspot: {
            title: this.$t('certifications_title.certifications_1'),
            description: '',
            type: 'list',
            content_style: '2',
            files: certifications.files
          }
        })
      }

      this.menus = this._.map(menus, menu => {
        menu._collapse = !this._.isEmpty(menu.children)
        menu._active = false
        return menu
      })
    },

    // 点击二级菜单
    handleMenuChange(e) {
      switch(e.name) {
        case 'hotspot':
          const hotspot = e.hotspot
          switch(hotspot.level) {
            case 'point':
              this.switchToHotspot(hotspot, {}, () => {
                const moveTo = hotspot.moveTo
                if (moveTo) {
                  setTimeout(() => {
                    const duration = this.getSwitchToDistance(moveTo) * 6000
                    this.currentPanorama.scene.lookTo(
                      {yaw: moveTo.yaw, pitch: moveTo.pitch},
                      {transitionDuration: duration, ease: val => val}
                    )
                  }, 500)
                }
              })
              break;
            default:
              this.switchToHotspot(hotspot, null)
          }
          break
      }
    },

    // 点击菜单
    hanldeMenuClick(menu) {
      if (!menu._active) {
        this.$refs.navMenu.hanldeMenuClick(menu)
      }
    },

    // 点击平面图触发
    handleFloorSelect(value) {
      let panorama = null
      if (this._.has(value, 'building')) {
        panorama = this._.first(this._.get(this._.find(this.scenes, scene => scene.summary.building == this._.get(value, 'building.key')), 'panoramas'))
      } else if (this._.has(value, 'panorama')) {
        panorama = this._.get(this.panoramas, this._.get(value, 'panorama'))
      }
      if (panorama) {
        const menu = this._.find(this.menus, { sceneUid: panorama.parentUid, type: 'audit' })
        if (menu && this.$refs.navMenu.activeMenu !== menu) {
          this.$refs.navMenu.hanldeMenuClick(menu, true)
        }
        this.switchTo(panorama)
      }
    },

    hideAllHotspots() {
      if (this.allHotspotsIsHidden === false) {
        this.allHotspotsIsHidden = true
        this._.each(this.hotspots, hotspot => {
          hotspot.hotspot && hotspot.hotspot.hide()
        })
      }
    },

    showAllHotspots() {
      if (this.allHotspotsIsHidden === true) {
        this.allHotspotsIsHidden = false
        this._.each(this.hotspots, hotspot => {
          hotspot.hotspot && hotspot.hotspot.show()
        })
      }
    },

    showSummary() {
      this.showTools = false
      this.showSceneContent = false
      this.showFloorPlann = true
      this.isSummary = true
      this.summaryIsHiding = false
      this.$refs.content.transition = false

      if (this.$refs.navMenu.activeMenu.type !== 'audit') {
        this.$refs.navMenu.selectFirstAuditMenu()
      } else {
        this.focusHotspot = this.$refs.navMenu.activeMenu.hotspot
      }
      this.$refs.content.show = true
    },

    hideSummary() {
      this.summaryIsHiding = true
      setTimeout(() => {
        this.isSummary = false
        this.$refs.content.show = false
        this.showTools = false
        // this.showFloorPlann = false
        this.showSceneContent = true
        setTimeout(() => {
          this.$refs.content.transition = true
          this.$nextTick(() => {
            this.$refs.content.show = true
            this.showFloorPlann = true
            this.showTools = true
          })
        }, 80)
      }, 300)

      if (this.showFAQ === false) {
        this.showFAQ = true
        setTimeout(() => {
          this.showFAQ = null
        }, 5000)
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/review.scss';
body {
  overflow: hidden;
}
</style>